var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 1.16797H2.49967C2.05765 1.16797 1.63372 1.34356 1.32116 1.65612C1.0086 1.96868 0.833008 2.39261 0.833008 2.83464V16.168C0.833008 16.61 1.0086 17.0339 1.32116 17.3465C1.63372 17.659 2.05765 17.8346 2.49967 17.8346H12.4997C12.9417 17.8346 13.3656 17.659 13.6782 17.3465C13.9907 17.0339 14.1663 16.61 14.1663 16.168V7.0013M8.33301 1.16797L14.1663 7.0013M8.33301 1.16797V7.0013H14.1663",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.0da7d48f9dfee6e95d822e1201a1b3be.svg";
export { ForwardRef as ReactComponent };